export default __webpack_public_path__ + "static/Pattern2-0860f687a51c2024c266421541c2c5fe.png";